module.exports = __webpack_public_path__ + "img/live-claim-feed.1ae27155.png";